module.exports = __webpack_public_path__ + "static/img/ent-14.5e867f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-14.jpg
// module id = 21Rc
// module chunks = 52